// VibeVox: версия брендинг-форка Chatwoot.
// Показывается: (1) в левом нижнем углу сайдбара (Sidebar.vue) как «© VibeVOX.com X.Y.Z»,
// (2) в футере настроек (BuildInfo.vue).
//
// ПРАВИЛО ВЕРСИОНИРОВАНИЯ (владелец):
//   • старт 0.0.1; каждый деплой = +1 к младшему разряду;
//   • при достижении 9 — перенос в следующий «столбик»
//     (0.0.1 → 0.0.2 → … → 0.0.9 → 0.1.0 → … → 0.9.9 → 1.0.0).
//   • ПЕРЕД деплоем: поднять версию (node VIBEVOX_BRANDING/bump-version.mjs) и показать «было → стало».
//   • ПОСЛЕ деплоя: показать версию с живого app.vibevox.pro для сверки, что выкатилось верно.
//
// НЕ редактировать вручную — пусть это делает bump-version.mjs на деплое.
export const VIBEVOX_VERSION = '0.1.7';
